<template>
  <div align="center">
    <GChart
      :settings="{ packages: ['gauge'] }"
      type="Gauge"
      :data="chartData"
      :options="chartOptions"
    />
  </div>
</template>

<script>
export default {
  props: [
    "value",
    "title",
    "max",
    "greenFrom",
    "greenTo",
    "redFrom",
    "redTo",
    "redColor",
    "yellowFrom",
    "yellowTo",
    "yellowColor",
    "minorTicks",
    "height",
    "width",
  ],
  name: "Dashboard",
  data() {
    return {
      chartData: [],

      chartOptions: {
        width: this.width,
        height: this.height,
        redFrom: this.redFrom,
        redTo: this.redTo,
        redColor: this.redColor,
        greenFrom: this.greenFrom,
        greenTo: this.greenTo,
        yellowFrom: this.yellowFrom,
        yellowTo: this.yellowTo,
        yellowColor: this.yellowColor,
        minorTicks: this.minorTicks,
        max: this.max,
        min: 0,
      },
    };
  },
  watch: {
    value: function() {
      this.fillData();
    },
  },
  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      this.chartData = [
        ["Label", "Value"],
        [this.title, Number(this.value)],
      ];
    },
  },
};
</script>
